import * as React from 'react';
import {
  InputContainer,
  Label,
  InputComponent,
  Star,
} from './currency-input-components';
import CurrencyInput from 'react-currency-input-field';

type Props = {
  label?: string;
  placeholder?: string;
  name?: string;
  value?: string;
  onChange?: (e: any) => void;
  register?: any;
  id?: string;
  star?: string;
  noBottom?: boolean;
  precision?: number;
  backgroundColor?: string;
  disabled?: boolean;
};

export default function Input({
  label,
  placeholder,
  name,
  value,
  onChange,
  register,
  id,
  star,
  noBottom,
  precision,
  backgroundColor,
  disabled,
}: Props) {
  return (
    <InputContainer noBottom={noBottom}>
      {label && <Label>{label}</Label>}
      {star && <Star>{star}</Star>}
      <InputComponent backgroundColor={backgroundColor}>
        <CurrencyInput
          prefix="$"
          decimalsLimit={precision ? precision : 2}
          placeholder={placeholder}
          name={name}
          value={value}
          disabled={disabled}
          onValueChange={onChange}
          ref={register}
          id={id}
          allowDecimals={true}
        />
      </InputComponent>
    </InputContainer>
  );
}
